import React from "react";
import { Modal, Button, Table } from "react-bootstrap";

const ViewPurchaseDetails = ({ show, onHide, purchaseData }) => {
  if (!purchaseData) return null;
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Purchase Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>
            <strong>Invoice ID:</strong> {purchaseData.invoiceId}
          </p>
          <p>
            <strong>Supplier:</strong> {purchaseData.supplierName}
          </p>
          <p>
            <strong>Invoice Date:</strong> {purchaseData.invoiceDate}
          </p>
          <p>
            <strong>Sub Total:</strong> ₹{purchaseData.subTotal}
          </p>
        </div>

        <h5 className="mt-4">Items</h5>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Batch No</th>
              <th>HSN Code</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Expiry Date</th>
              <th>Tax</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {purchaseData?.items?.map((item, index) => (
              <tr key={index}>
                <td>{item?.name}</td>
                <td>{item?.batchNumber}</td>
                <td>{item?.hsnCode}</td>
                <td>{item?.quantity}</td>
                <td>{item?.purchasePrice}</td>
                <td>{item?.expiryDate.split("T")[0]}</td>
                <td>{item?.taxRate}%</td>
                <td>{item?.totalAmount}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewPurchaseDetails;
